module.exports = __webpack_public_path__ + "static/media/icon-menu-outline.90528849.svg";